<template>
  <div>
    <component style="display: none" :is="show_document"></component>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>{{ $t('orders') }}</strong>
              </CCol>
              <CCol style="text-align: end;">
                <!--                                <CButton @click="AddAllRefer()" size="sm" color="primary">-->
                <!--                                    {{ $t('reOrder') }}-->
                <!--                                </CButton>-->
              </CCol>

            </CRow>
            <CRow>
              <CCol col="3">
                <date-picker

                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>
              <CCol col="3">
                <CSelect :value.sync="selected_type"
                         :options="[{label:$t('all'),value:0},{label:$t('orders'),value:1},{label:$t('reorders'),value:2}]"
                />
              </CCol>
              <CCol col="1">
                <CButton @click="get_all_data" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>
<CButton

    v-if="id_checkbox_items.length>0 && get_access('multi_factor_finalize')"
    color="primary" outline @click="Finalize(0)">{{ $t('buttons.finalize') }}</CButton>
            <CCard v-if="submit_refer!=0">
              <CCardHeader>
                <strong>{{ $t('components.referToUser') }}</strong>
              </CCardHeader>
              <CCardBody>
                <CForm>


                  <CCol sm="6" md="4">
                    <CRow>
                      <CCol sm="12">
                        <treeselect
                            v-model="refer_person"

                            :async="true"
                            :load-options="load_persons"
                            :placeholder="$t('components.searchUser')"
                            :normalizer="normalizer_persons"
                        />

                      </CCol>
                    </CRow>

                  </CCol>

                </CForm>
              </CCardBody>
              <CCardFooter>
                <CButton @click="insert_refer()" type="submit" size="sm" color="primary">
                  <CIcon name="cil-check-circle"/>
                  {{ $t('components.referToUser') }}
                </CButton>

                <CButton @click="submit_refer = 0,id_checkbox_items=[]" type="reset" size="sm"
                         color="danger">
                  <CIcon name="cil-ban"/>
                  {{ $t("buttons.cancel") }}
                </CButton>
              </CCardFooter>
            </CCard>
            <CDataTableFixed
                :items="items_sell_filtered"
                :fields="fields"
                column-filter
                @row-clicked="table_row_clicked"
height="300px"
                hover
                sorter
                border
                striped
                :sorter-value="{column:'recId',asc:false}"

            >
              <template #row="{item,index}">

                <td>
                  <p class="text-center">{{ index + 1 }}</p>
                </td>

              </template>
              <template #docDate="{item}">

                <td>
                  <p class="text-center">{{ get_date(item.docDate) }}</p>

                </td>

              </template>

              <template #warehouse="{item}">
                <td>
                  <p>{{ item.placeName }}</p>

                </td>

              </template>
              <template #masterCode="{item}">
                <td>
                  <p class="text-center">{{ item.masterCode }}</p>

                </td>

              </template>
              <template #totalPrice="{item}">

                <td>
                  <p v-if="item.totalPrice!=null" class="text-right">{{ get_currency(item.totalPrice) }}</p>

                </td>


              </template>
              <template #partyName="{item}">
                <td>
                  <p>{{ item.partyName }}</p>
                </td>
              </template>
              <template #partyCode="{item}">
                <td>
                  <p class="text-center">{{ item.partyCode }}</p>
                </td>
              </template>

              <template #createdBy="{item}">

                <td>
                  <p>{{ item.createdBy }}</p>
                </td>

              </template>


              <template #operation="{item}">
                <td>

                  <CButton
                      v-if="item.is_pre==1"
                      size="sm"
                      :title="$t('buttons.delete')"
                      @click="delete_re_order(item)"
                  >
                    <CIcon name="cil-trash" class="text-danger"/>
                  </CButton>
                  <CButton
                      v-if="item.is_pre!=1"
                      size="sm"
                      :title="$t('buttons.delete')"
                      @click="delete_item_dialog(item)"
                  >
                    <CIcon name="cil-trash" class="text-danger"/>
                  </CButton>


                </td>
              </template>

              <template #select="{item}">
                <td>

                  <CCol v-if="item.statusId ==0 && item.is_pre!=1">

                    <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                           :value="item.recId"/>

                  </CCol>

                </td>
              </template>
              <template #caption>
                <tr class="total-table">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{$t('totalPrice')}}</td>

                  <td>{{get_currency(calculate_items(items_sell_filtered,'totalPrice'))}}</td>
                  <td></td>
                  <td></td>

                </tr>

              </template>

            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',


      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,
      id_checkbox_items: [],
      type_items: [],
      item_sell_array: [],
      selected_type: 0,
      items_sell_filtered: [],
      items_sell_pre_orders: [],
      items_sell: [],
      table_clicks_timer: '',
      table_clicks: 0,

      fields: [
        {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('orderId'), _style: 'width:10%'},
        // {key: 'partyCode', label: this.$t('customerCode'), _style: 'width:10%'},
        // {key: 'partyName', label: this.$t('customerName'), _style: 'width:20%'},
        {key: 'createdBy', label: this.$t('docCreator'), _style: 'width:15%'},

        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:10%'},

        {key: 'operation', label: "", _style: 'width:3%', sorter: false, filter: false},
        {key: 'select', label: "", _style: 'width:3%', sorter: false, filter: false},

      ],

      details: [],

      status_form: 0,
      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },

    }
  }, mounted() {

    this.start_date = this.get_day_before_today_in_day(6);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();
    this.get_sys();

    bus.$on("reorder_added", (data) => {
      this.get_all_data()
    });
    bus.$on("inventory_adjustment_added", (data) => {
      this.get_all_data()
    });
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.person_id': function () {
      this.get_all_data();
    },
    'start_date': function () {
      // this.get_all_data();
    },
    'end_date': function () {
      // this.get_all_data();
    },
    'selected_type': function () {
      if (this.selected_type == 0) {
        this.items_sell_filtered = this.items_sell.concat(this.items_sell_pre_orders);

      }
      if (this.selected_type == 1) {
        this.items_sell_filtered = this.items_sell
      }
      if (this.selected_type == 2) {
        this.items_sell_filtered = this.items_sell_pre_orders
      }
    }
  },
  methods: {
    delete_re_order(item) {
      var self = this;

      const formData = new FormData();
      formData.append("id", item.recId);
      axios.post('DelReOrder', formData, {}).then(function (response) {

        var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(response);
        self.get_all_data()
        // items = content_cats.orders;
        bus.$emit('delete_re_order_called', true)

      }).catch(function (error) {

        console.log(error);
      });

    },
    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;

        self.type_items = [];
        var obj = {label: self.$t('all'), value: 0}

        self.type_items.push(obj);

        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          if (val.titleType == 28) {
            self.type_items.push(obj);
          }

        });

        self.selected_type = self.type_items[0].value


      }).catch(function (error) {

        console.log(error);
      });

    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.table_clicks = 0

        this.goShowDocument(item)

      }

    },
    get_all_data() {
      this.get_lists_sell();

    },

    get_lists_sell() {

      var self = this;


      const formData = new FormData();

      var url = "GetDocsByParams";
      formData.append("docType", 10);
      if (self.$route.params.person_id != null) {
        formData.append("PersonId", self.$route.params.person_id);

      } else {
        formData.append("PersonId", 0);

      }

      // formData.append("id", 3);

      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          self.items_sell = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });

          self.items_sell = self.items_sell.filter(x => x.statusId == 0)
          self.items_sell_filtered = self.items_sell
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },

    Finalize(index) {
      var self = this;


      const formData = new FormData();

      var url = "AddFactorToFinal";

      formData.append("id", this.id_checkbox_items[index]);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
         if(index>=self.id_checkbox_items.length-1){
           self.get_all_data()
         }else{
           self.Finalize(index+1)
         }
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    send_to_customer(item) {
      var self = this;


      const formData = new FormData();

      var url = "SendFactorToTelegramBoth";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goReturnDocument(item) {
      this.$router.push({
        path: '/dashboard/documents/return/' + item.recId + "/false",
        params: {passed_data: "salam hamidddd"}
      });
    },
    goShowDocument(item) {

        // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
        window.open('/dashboard/accounting/adjustment/show/' + item.recId)

    },
    goPrintDocument(item) {
      bus.$emit("print_confirm", item.recId);


    },
    AddRefer(item) {
      this.submit_refer = item.recId;
    },

    AddAllRefer() {
      this.submit_refer = -1;
      if (this.id_checkbox_items.length == 0) {
        console.log("validate form is false" + this.validate_errors);
        this.submit_refer = 0;

      }
    },

    insert_refer() {
      let self = this;

      if (this.submit_refer != -1) {


        this.id_checkbox_items = [];
      } else {
        if (this.id_checkbox_items.length == 0) {
          console.log("validate form is false" + this.validate_errors);
          self.submit_refer = 0;
          self.id_checkbox_items = [];

          return true;
        }

      }
      if (this.refer_person == null) {
        console.log("validate form is false" + this.validate_errors);

        return true;
      }
      let url;
      // if (this.status_form == 0) {
      url = "AddFactorRefer";
      // }
      if (this.submit_refer != -1) {
        const formData = new FormData();

        formData.append('PersonId', this.refer_person);

        formData.append('MasterFactorId', this.submit_refer);
        axios.post(url, formData, {}).then((res) => {


          self.submit_refer = 0;
          self.id_checkbox_items = [];

          self.refer_person = null;

          self.$root.modal_component.show_api_response_modals(res);
          self.get_all_data()
        })
            .catch(function (error) {

              console.log(error);
            });
      } else {
        self.id_checkbox_items.forEach((val) => {

          const formData = new FormData();

          formData.append('PersonId', this.refer_person);

          formData.append('MasterFactorId', val);
          axios.post(url, formData, {}).then((res) => {


          })
              .catch(function (error) {

                console.log(error);
              });
        });
        self.id_checkbox_items = [];
        self.submit_refer = 0;
        self.id_checkbox_items = [];

        self.refer_person = null;

        this.get_all_data()
      }


    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.recId;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteFactorMaster";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        // self.get_lists();
        //  this.$router.push({ path: '/dashboard/documents/daily-list/0'});
        self.get_all_data();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

  },

}

</script>
